<template>
  <!-- 标准库 删除操作 转移并删除弹框 20-08-06 -->
  <!-- 请求数据在此接口使用 不复用 -->
  <simpleDiag
    :title="title"
    :isShow="isShow"
    width="700px"
    @close="close"
    @confirm="confirm">
    <div class="trans_del_diag" style="margin-bottom: -10px;">
      <!-- 原始表格 -->
      <div class="part part1">
        <div class="part_label">待处理数据:</div>
        <v-table
          ref="table"
          v-if="isShow"
          :is-vertical-resize="false"
          :is-horizontal-resize="false"
          style="width:100%;"
          title-bg-color="#EFF3F5"
          :columns="col"
          :table-data="oriData"
          :row-height="32"
          :title-row-height="32"
          :show-vertical-border="false"
          :show-horizontal-border="true"
        ></v-table>
      </div>
      <!-- 查询表格 -->
      <div class="part part2">
        <div class="search_content">
          <Input v-model.trim="value" placeholder="请输入名称" @keyup.enter.native="search" />
          <i class="iconfont iconsousuo" @click="search"></i>
        </div>
        <div class="part_label">相似数据:</div>
        <v-table
          v-if="isShow"
          ref="table1"
          class="real_table"
          :height="130"
          v-loading="loading"
          :is-vertical-resize="true"
          :is-horizontal-resize="false"
          style="width:100%;"
          title-bg-color="#EFF3F5"
          :error-content-height="100"
          :columns="col2"
          :table-data="realTableData.length ? realTableData : []"
          :row-height="32"
          :title-row-height="32"
          :show-vertical-border="false"
          :show-horizontal-border="true"
          :column-cell-class-name="cellClassFn"
          :rowClick="rowClick"
          error-content="请确定待处理数据"
        ></v-table>
      </div>
      <div class="info">对应关系转移完成后并删除数据</div>
    </div>
  </simpleDiag>
</template>
<script>
import simpleDiag from '@/components/dialogs/simpleDiag'
import '@/components/vue-easytable/themes-base/index.css'
import { VTable } from '@/components/vue-easytable'
import { msg } from '@/utils/index'

import { replaceData, delMaindataNew } from '@/api/goodStand'
export default {
  name: 'transDiag',
  components: { simpleDiag, VTable },
  props: {
    isShow: Boolean, // 显示与否
    oriData: {
      type: Array,
      default: () => {
        return [{}]
      }
    }, // 原始表格数据
    title: { // 表格标题
      type: String,
      default: '转移并删除'
    },
    esName: String // 后台需要参数
  },
  data() {
    return {
      col: [
        { field: 'id', title: 'ID', width: 80, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
        { field: 'p_name', title: '省', width: 80, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
        { field: 'city_name', title: '市', width: 80, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
        { field: 'ad_name', title: '区', width: 80, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
        { field: 'name', title: '终端名称', width: 158, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
        { field: 'is_clean', title: '关联清洗', width: 90, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
        { field: 'is_target', title: '关联目标', width: 90, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true }
      ],
      col2: [
        {
          field: 'isActive', title: '操作', width: 44, titleAlign: 'center', columnAlign: 'center',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field]) {
              return '<i class="iconfont icondanxuan-xuanzhong" style="color:#3385F2; position: relative; top: 0px;"></i>'
            } else {
              return '<i class="iconfont icondanxuan-weixuanzhong" style=" color:#BECAD6; position: relative; top: 0px;"></i>'
            }
          }
        },
        { field: 'id', title: 'ID', width: 76, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
        { field: 'p_name', title: '省', width: 80, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
        { field: 'city_name', title: '市', width: 80, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
        { field: 'ad_name', title: '区', width: 80, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
        { field: 'name', title: '终端名称', width: 158, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
        { field: 'is_clean', title: '关联清洗', width: 70, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
        { field: 'is_target', title: '关联目标', width: 70, titleAlign: 'left', columnAlign: 'left', overflowTitle: true }
      ],
      loading: false,
      value: '', // 搜索参数
      realTableData: [],
      curId: '' // 选中行的id
    }
  },
  computed: {
    realCol() {
      if (this.$route.name === 'shangyeData') {
        return [
          { field: 'id', title: 'ID', width: 95, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
          { field: 'p_name', title: '省', width: 95, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
          { field: 'city_name', title: '市', width: 95, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
          { field: 'ad_name', title: '区', width: 95, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
          { field: 'name', title: '终端名称', width: 173, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
          { field: 'is_clean', title: '关联清洗', width: 105, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true }
        ]
      } else {
        return [
          { field: 'id', title: 'ID', width: 80, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
          { field: 'p_name', title: '省', width: 80, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
          { field: 'city_name', title: '市', width: 80, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
          { field: 'ad_name', title: '区', width: 80, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
          { field: 'name', title: '终端名称', width: 158, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
          { field: 'is_clean', title: '关联清洗', width: 90, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
          { field: 'is_target', title: '关联目标', width: 90, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true }
        ]
      }
    },
    realCol2() {
      if (this.$route.name === 'shangyeData') {
        return [{
          field: 'isActive', title: '操作', width: 44, titleAlign: 'center', columnAlign: 'center',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field]) {
              return '<i class="iconfont icondanxuan-xuanzhong" style="color:#3385F2; position: relative; top: 0px;"></i>'
            } else {
              return '<i class="iconfont icondanxuan-weixuanzhong" style="position: relative; top: 0px;"></i>'
            }
          }
        }].concat([
          { field: 'id', title: 'ID', width: 86, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
          { field: 'p_name', title: '省', width: 91, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
          { field: 'city_name', title: '市', width: 91, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
          { field: 'ad_name', title: '区', width: 91, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
          { field: 'name', title: '终端名称', width: 170, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
          { field: 'is_clean', title: '关联清洗', width: 81, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true }
        ])
      } else {
        return [{
          field: 'isActive', title: '操作', width: 44, titleAlign: 'center', columnAlign: 'center',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field]) {
              return '<i class="iconfont icondanxuan-xuanzhong" style="color:#3385F2; position: relative; top: 0px;"></i>'
            } else {
              return '<i class="iconfont icondanxuan-weixuanzhong" style="position: relative; top: 0px;"></i>'
            }
          }
        }].concat([
          { field: 'id', title: 'ID', width: 76, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'p_name', title: '省', width: 80, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'city_name', title: '市', width: 80, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'ad_name', title: '区', width: 80, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'name', title: '终端名称', width: 158, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'is_clean', title: '关联清洗', width: 70, titleAlign: 'left', columnAlign: 'left', overflowTitle: true },
          { field: 'is_target', title: '关联目标', width: 70, titleAlign: 'left', columnAlign: 'left', overflowTitle: true }
        ])
      }
    },
    paramType() { // 删除接口参数 跟路径有关
      const obj = {
        'kehuData': 'Standard',
        'companyData': 'ShengChanQiYe',
        'shangyeData': 'ServiceInfoCorp',
        'yiliaoData': 'YiLiaoJiGou',
        'yaodianData': 'ServiceInfoShop',
        'yiyuanData': 'ServiceInfoHospital',
        'zhongduanData': 'DiSanZhongDuan'
      }
      return obj[this.$route.name]
    }
  },
  methods: {
    close() {
      this.value = ''
      this.realTableData = []
      this.curId = ''
      this.$emit('close')
    },
    confirm() {
      let canFlag = true // 是否需要迁移
      const params = {
        ids: this.oriData[0].id,
        type: this.paramType
      }
      if (this.$route.name === 'shangyeData') { // 商业清洗只有是否关联清洗
        if (this.oriData[0]['is_clean'] === '否') {
          canFlag = false
        }
      } else {
        if (this.oriData[0]['is_clean'] === '否' && this.oriData[0]['is_target'] === '否') {
          canFlag = false
        }
      }
      if (canFlag) { // 需要迁移判断有没有选择迁移id
        if (!this.curId) {
          msg.call(this, '请选择待转移的终端')
          return
        }
        params.replace_ids = this.curId
      }
      // this.$emit('confirm')
      delMaindataNew(params).then(res => {
        if (res.code === 0) {
          this.$emit('confirm')
          msg.call(this, '删除成功')
          this.value = ''
          this.realTableData = []
          this.curId = ''
        } else {
          msg.call(this, '数据删除失败')
        }
      })
    },
    search() {
      this.loading = true
      replaceData({
        app_name: this.esName,
        name: this.value,
        old_std_id: this.oriData[0].id
      }).then(res => {
        this.loading = false
        if (res.code === 0) {
          this.realTableData = res.result.map(obj => {
            obj.isActive = false
            if (this.$route.name === 'shangyeData') {
              obj.is_target = ''
            }
            return obj
          })
        }
      })
    },
    cellClassFn(rowIndex, field, rowData) {
      if (rowData.id === this.curId) {
        // 这个样式是给td加的
        // return 'clean-edit-cell--active'
        return 'clean-edit-cell--active-fake'
      }
    },
    rowClick(rowIndex, rowData, column) {
      // if (Number(rowData.id) === Number(this.curId)) {
      //   this.curId = ''
      // } else {
      //   this.curId = rowData.id
      // }
      this.curId = rowData.id
      this.realTableData.forEach((obj, index) => {
        if (index === rowIndex) {
          this.$set(this.realTableData[index], 'isActive', true)
        } else {
          this.$set(this.realTableData[index], 'isActive', false)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .v-table-views {
  border-color: #D9E2EF;
}
/deep/ .v-table-header:before {
  width: 0px;
}
.part {
  width: 660px;
  position: relative;
}
.part1 {
  margin-bottom: 50px;
}
.part_label {
  color: #5D6F80;
  font-size: 12px;
  line-height: 12px;
  margin-bottom: 12px;
  font-weight: 400;
}
.search_content {
  position: absolute;
  right: 0px;
  top: -18px;
  width: 220px;
  /deep/ .ivu-input-wrapper {
    .ivu-input {
      height: 32px;
      line-height: 32px;
      width: 220px;
      padding-right: 45px;
    }
  }
  .iconsousuo {
    position: absolute;
    right: 10px;
    top: 4px;
    cursor: pointer;
    font-weight: 700;
    &:hover {
      color: #C9D5DF;
    }
  }
}
.info {
  height: 14px;
  line-height: 14px;
  font-size: 12px;
  color: #B5C2D0;
  margin-top: 16px;
  padding-left: 10px;
  position: relative;
  &:after {
    display: block;
    content: '*';
    position: absolute;
    color: #DFA338;
    left: 0px;
    top: 4px;
    transform: scale(1.5);
  }
}
.real_table {
  /deep/ .v-table-row {
    cursor: pointer;
  }
}
/deep/ .v-table-empty .v-table-empty-inner {
  color: #B5C2D0;
  font-size: 12px;
}
/deep/ .clean-edit-cell--active {
  position: relative;
  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 30px;
    border-bottom: 1px solid red;
    border-top: 1px solid red;
    top: 0px;
    left: 0px;
    z-index: 20;
    pointer-events: none;
  }
}
/deep/ .clean-edit-cell--active:first-child::after {
  left: 2px;
  border-left: 1px solid red;
}
/deep/ .clean-edit-cell--active:last-child::after {
  border-right: 1px solid red;
}
/deep/ .v-table-row:last-child {
  .v-table-body-cell {
    border-bottom: none;
  }
  .clean-edit-cell--active {
    &:after {
      height: 29px;
    }
  }
}
// 纯粹为了兼容row1 row2
/deep/ .v-table-row:first-child {
  .v-table-body-cell {
    border-bottom: 1px solid rgb(221, 221, 221);
  }
}
/deep/ .v-table-row:nth-child(2) {
  .v-table-body-cell {
    border-bottom: 1px solid rgb(221, 221, 221);
  }
}
// 纯粹结束
/deep/ .v-table-title-cell {
  color: #5D6F80;
  border-bottom: none;
  span {
    font-weight: 500;
  }
}
/deep/ .v-table-body-cell {
  color: #5D6F80;
  padding: 0 10px;
  border-color: #E9EEF4 !important;
}
</style>
